
<template>
    <div id="VerseOfTheDay">
        <a class="waves-effect waves-light btn-large transparent modal-trigger z-depth-0" v-on:click="open()">Subscribe to the Verse of the Day</a>
        <modal name="VerseOfTheDay" transition="pop-out" :width="modalWidth" height="auto" @before-open="beforeOpen" @before-close="beforeClose" :resizable="true" :adaptive="true">
            <div class="row">
                <ValidationObserver v-slot="{ handleSubmit, reset }">
                    <form @submit.prevent="handleSubmit(onSubmit)" @reset.prevent="reset">
                        <div class="row">
                            <div class="title">Verse of the Day: Subscribe</div>
                            <div class="close"><a @click="$modal.hide('VerseOfTheDay')"><i class="material-icons">close</i></a></div>
                        </div>
                        <div class="row">
                            <div class="input-field col s12 m6">
                                <ValidationProvider rules="required" v-slot="{ errors }">
                                    <label for="Name" class="active">Name *</label>
                                    <input id="Name" type="text" class="validate" v-model="form.Name" :disabled="isDisabled ? 'disabled' : false" maxlength="100" oninput="javascript: if (this.value.length > this.maxlength) this.value=this.value.slice(0,this.maxlength);"/>
                                    <span>{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="input-field col s12 m6">
                                <ValidationProvider rules="required|phone" v-slot="{ errors }">
                                    <label for="Phone" class="active">Phone *</label>
                                    <input id="Phone" type="text" class="validate" v-model="form.Phone" :disabled="isDisabled ? 'disabled' : false" maxlength="10" oninput="javascript: if (this.value.length > this.maxlength) this.value=this.value.slice(0,this.maxlength);"/>
                                    <span>{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-field col s12 center">
                                <div v-if="success == true" class="success">You have been subscribed.</div>
                                <button v-if="success == false" class="waves-effect waves-light btn" type="submit" :disabled="isDisabled ? 'disabled' : false">Subscribe</button>
                                <div class="reset-div"><button class="transparent" v-on:click="resetForm()" type="reset">Reset Form</button></div>
                            </div>
                        </div>       
                    </form>
                </ValidationObserver>
            </div>       
        </modal>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import M from 'materialize-css';
import VerseService from '../services/Verses.js';

    extend('phone', value => {
        var patt = new RegExp(/^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im);
        if (value.length > 0) {
            if (!patt.test(value)) {
                return 'Enter a valid phone number.';
            }
            else {
                return true;
            }
        }
    });

    // Override the default message.
    extend('required', {
        ...required,
        message: 'Required'
    });


export default {
    name: "VerseOfTheDay",
    components: { ValidationProvider, ValidationObserver },
    props: ['votd'],
    data: function() {
        return {
            modalWidth: 700,
            form: {
                Name: "",
                Phone: "",
                Image: "",
                Verse: ""
            },
            isDisabled: false,
            success: false,
        }
    },
    mounted: function() {
        M.updateTextFields();
    },
    created: function() {
        this.modalWidth = window.innerWidth < this.modalWidth
        ? this.modalWidth / 2
        : this.modalWidth
    },
    methods: {
        open: function() {
            this.$modal.show('VerseOfTheDay', 
                {
                    height: 'auto'
                }
            );
        },
        onSubmit: function() {
            this.form.Image = this.votd.Image;
            this.form.Verse = this.votd.Verse;

            var self = this;
            this.isDisabled = true;
            this.success = false;
            const payload = this.form;
            VerseService.subscribe(payload).then(function() {
                self.success = true;
            });
        },
        beforeOpen: function() {
            document.querySelector("body").classList.add("modal-open");
        },
        beforeClose: function() {
            document.querySelector("body").classList.remove("modal-open");
            this.resetForm();
        },
        resetForm: function() {
            this.success = false;
            this.isDisabled = false;
            this.form = {
                Name: "",
                Phone: ""
            }
        }
    },
    computed: {
        buttonDisabled: function() {
            if (this.form.Name == '' && this.form.Phone == "") {
                return false;
            }
            else     {
                return true;
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .modal-trigger {
        font-size: 1.25rem;
        color: rgba(91,124,138, 1);
        transition: all 0.5s ease;
        cursor: pointer;
        border: 1px solid rgba(91,124,138, 1);
        /* padding: 1rem; */
    }

    .modal-trigger:hover {
        color: #fff;;
        background: rgba(91,124,138, .7) !important;
        border: 1px solid rgba(91,124,138, .7);
    }

    button {
        /* line-height: 58px; */
        /* font-size: 1.25rem; */
        /* padding: 0px 50px; */
        background: rgba(91,124,138, .7);
    }

    button:hover {
        color: #fff;
        background: rgba(91,124,138, 1);
    }

    form {
        padding: 2rem 3rem;
        overflow-y: auto;
        max-height: 100vh;
        overflow-x: hidden;
    }

    form .row {
        margin-bottom: 0;
    }

    form .title {
        color: #000000;
        font-size: 1.5rem;
    }

    form input, 
    form textarea {
        /* color: #ffffff; */
        font-size: 1.25rem;
        font-family: 'NewhouseDTCond-ExtBold';
    }

    .title { 
        float: left;
    }
    
    .close {
        color: #000;
        /* position: absolute;
        right: 2rem;
        top: 2rem; */
        cursor: pointer;
        float: right;
    }
    .input-field {
        margin-bottom: 0;
    }

    .input-field span {
        color: red;
    }
    .v--modal {
        background: rgba(9,12,13, .9);
    }

    .reset-div {
        margin-top: 10px;
        cursor: pointer;
    }

    .success {
        color: #000;
        height: 35px;
        font-size: 1.5rem;
        font-family: 'NewhouseDTCond-ExtBold';
    }

    .reset-div button {
        color: #5b7c8a;
        background: transparent;
        border: none;
        cursor: pointer;
    }

    .v--modal-overlay .v--modal-box {
        overflow: auto;
    }
</style>
